import { jsx as _jsx } from "react/jsx-runtime";
import { Button as BaseButton } from '@base-ui/react/button';
import { forwardRef } from 'react';
import { iconButtonStyles } from './icon-button-styles';
/**
 * An icon-only action. Renders a `<button>` (via base-ui `Button`, which enforces button
 * semantics). `aria-label` is required since there is no visible text to derive an accessible
 * name from. For navigation, use `IconButtonLink`.
 */
export const IconButton = forwardRef(({ icon, variant = 'darkGrey', shape = 'square', className, disabled, ...props }, ref) => (_jsx(BaseButton, { ref: ref, className: iconButtonStyles({ variant, shape, className }), disabled: disabled, "aria-disabled": disabled || undefined, ...props, children: icon })));
IconButton.displayName = 'IconButton';
